import { z } from "zod/v4";

import { MarketRateScopeSchema } from "./market-rate-scope";
import { ShippingRateDtoSchema } from "./shipping-rates";

export const RateGroupTypeList = [
  "flatRate",
  "flatRateWithThreshold",
  "thresholdOnly",
  "tieredByPriceOrWeight",
  "custom",
] as const;

export type RateGroupType = (typeof RateGroupTypeList)[number];

export const ShippingRateGroupDtoSchema = z.object({
  id: z.uuid(),
  groupType: z.enum(RateGroupTypeList),
  position: z.number(), // rendering order
  rates: ShippingRateDtoSchema.array(),
  variationId: z.uuid(),
  /** Markets coverages this group serves at; absent, null or empty serves at
   * every placement (shared). */
  scopes: MarketRateScopeSchema.array().nullish(),
});

export type ShippingRateGroupDto = z.infer<typeof ShippingRateGroupDtoSchema>;

export const CreateShippingRateGroupDtoSchema =
  ShippingRateGroupDtoSchema.extend({
    id: z.uuid().optional(),
  });

export type CreateShippingRateGroupDto = z.infer<
  typeof CreateShippingRateGroupDtoSchema
>;
